// ABOUTME: Static privacy policy page for Daubly.
// ABOUTME: Describes data collection, usage, third-party services, and user rights.
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import MuiLink from '@mui/material/Link'

export function PrivacyPage() {
  return (
    <Container maxWidth="md">
      <Box py={6}>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Effective date: March 1, 2026
        </Typography>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Information We Collect
          </Typography>
          <Typography paragraph>
            When you create an account with Daubly, we collect the information you provide during
            sign-up, including your name and email address. This information is managed by our
            authentication provider, Clerk.
          </Typography>
          <Typography paragraph>
            We also collect the content you create while using Daubly: square packs, game
            configurations, and game history. We collect basic usage data such as pages visited
            and features used to help us improve the product.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            How We Use Your Information
          </Typography>
          <Typography paragraph>
            We use your information to provide and operate the Daubly service — creating and
            hosting bingo games, managing your square packs, and letting you join games others
            have created.
          </Typography>
          <Typography paragraph>
            We use your email address to send you important notices about your account. We do
            not send marketing emails or share your email with third parties for advertising.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Third-Party Services
          </Typography>
          <Typography paragraph>
            Daubly uses <strong>Clerk</strong> for authentication. When you sign in, Clerk handles
            your credentials and issues a secure token to our servers. Clerk's privacy policy
            is available at{' '}
            <MuiLink href="https://clerk.com/privacy" target="_blank" rel="noopener noreferrer">
              clerk.com/privacy
            </MuiLink>
            .
          </Typography>
          <Typography paragraph>
            We do not sell your data to third parties or use it for advertising purposes.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Data Retention
          </Typography>
          <Typography paragraph>
            We retain your account data for as long as your account is active. If you delete your
            account, we will delete your personal information and game data within 30 days.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Your Rights
          </Typography>
          <Typography paragraph>
            You may request access to, correction of, or deletion of your personal data at any
            time by contacting us. You may also delete your account directly from your account
            settings.
          </Typography>
          <Typography paragraph>
            If you are located in the European Economic Area, you have additional rights under
            the General Data Protection Regulation (GDPR), including the right to data
            portability and the right to lodge a complaint with a supervisory authority.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Contact Us
          </Typography>
          <Typography paragraph>
            If you have any questions about this Privacy Policy or how we handle your data,
            please contact us at{' '}
            <MuiLink href="mailto:privacy@daubly.com">privacy@daubly.com</MuiLink>.
          </Typography>
        </Box>
      </Box>
    </Container>
  )
}
